const runtimeConfig = window.__RUNTIME_CONFIG__ || {}

const getRuntimeConfig = (key, fallback = '') => {
  const runtimeValue = runtimeConfig[key]
  if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== '') {
    return runtimeValue
  }

  const buildTimeValue = process.env[key]
  if (buildTimeValue !== undefined && buildTimeValue !== null && buildTimeValue !== '') {
    return buildTimeValue
  }

  return fallback
}

const appConfig = {
  bookingService: getRuntimeConfig('REACT_APP_BOOKING_SERVICE', ''),
  environment: getRuntimeConfig('REACT_APP_ENV', ''),
  azureClientId: getRuntimeConfig('REACT_APP_AZURE_CLIENT_ID', ''),
  azureTenantId: getRuntimeConfig('REACT_APP_AZURE_TENANT_ID', 'common'),
  azureRedirectUri: getRuntimeConfig('REACT_APP_AZURE_REDIRECT_URI', `${window.location.origin}/login`),
}

export { appConfig, getRuntimeConfig }
